import { React, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Layout, Table, Button, PageHeader } from "antd";
import {
  RightLayoutContainer,
  OtherPages,
  PageTitleComp,
} from "../styledElements";
import logoCompany from "../../Assets/Images/logo.svg";
import Iconmoon from "../../Components/IconsFiles/icon";
import * as htmlToImage from "html-to-image";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { exportAllParentReelDetails } from "../../Services/productionPlanningServices";
import { useReactToPrint } from "react-to-print";
import { lengthUnit, weightUnit } from "../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../Utils/helper/helper";
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const PrintData = styled.div`
  padding: 0px;
  margin: 40px auto;
  background-color: #fff;
  width: 845px;
`;

const ExportHeader = styled.div`
  background-color: #faf9f8;
  padding: 10px 15px;
  .file-header {
    display: flex;
    justify-content: space-between;
  }
  .file-header-logo {
    width: 130px;
    display: flex;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .client-name {
    width: 25%;
  }
  .client-name h4 {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    margin: 0px;
  }
  .client-name h6 {
    font-style: italic;
    color: #605e5c;
    font-size: 10px;
    margin: 0px;
  }
  .client-data {
    display: flex;
    > div {
      width: 50%;
      label {
        color: #000;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
      span {
        color: #605e5c;
        font-size: 9px;
        font-family: var(--sf-pro-display-m);
        display: block;
      }
    }
  }
`;

const ExportTable = styled.div`
  table {
    width: 100%;
  }
  thead th {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
  }
  td {
    border-bottom: 1px solid #000;
  }

  th,
  td {
    text-align: left;
    padding: 5px 5px;
  }
  th {
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
    font-family: var(--sf-pro-text);
  }
  p {
    margin: 0;
    font-family: var(--sf-pro-text);
  }
  .order-d {
    p {
      text-transform: uppercase;
      font-size: 7px;
      font-weight: 600;
    }
    .order-d-l {
      p {
        text-transform: none;
        color: #605e5c;
        font-size: 7px;
        font-weight: 400;
      }
    }
  }
  .date {
    color: #000;
    font-size: 8px;
    font-weight: 600;
  }
  .p-detail {
    font-size: 7px;
    font-weight: 600;
    color: #605e5c;
  }
  .factor {
    color: #000;
    font-size: 7px;
    font-weight: 600;
    font-style: italic;
  }
  .p-ton {
    font-size: 8px;
    font-weight: 600;
    color: #000;
  }
  .reel {
    font-size: 8px;
    color: #605e5c;
    font-style: italic;
  }
  .remark {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 110px;
    line-height: 1.2;
  }
  .address {
    font-size: 8px;
    color: #000000;
    font-weight: 500;
    max-width: 170px;
    line-height: 1.2;
  }
  .ms-2 {
    width: 50px;
  }
  .f-10 {
    font-size: 10px !important;
  }
`;

const ExportAdditional = styled.div`
  background-color: #e0e2e8;
  padding: 25px 15px 20px;
  margin: 20px 0;
  .export-additional {
    display: flex;
    flex-wrap: wrap;
    .additional-col {
      flex: 0 0 33.3%;
      max-width: 33.3%;
    }
  }
  .additional-col {
    label,
    p {
      font-family: var(--sf-pro-display-m);
      color: #3b3a39;
      line-height: 15px;
      margin-bottom: 6px;
      font-size: 12px;
    }
    label {
      font-size: 14px;
    }
  }
`;

function addScript(url) {
  const script = document.createElement("script");
  script.type = "application/javascript";
  script.src = url;
  document.head.appendChild(script);
}

addScript(
  "https://raw.githack.com/eKoopmans/html2pdf/master/dist/html2pdf.bundle.js"
);

const PrintJobCardPdf = (props) => {
  const [parentReelDetails, setParentReelDetails] = useState();
  const [product, setProduct] = useState();
  const [showLoader, setLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const [jobId, setJobId] = useState(location.state.jobId);
  const [jobcardCode, setjobcardCode] = useState(location.state.jobcardCode);
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const exportHandler = () => {
    const input = document.getElementById("export-content");
    html2canvas(input, { useCORS: true, allowTaint: true, scrollY: 0 }).then(
      (canvas) => {
        const image = { type: "jpeg", quality: 0.98 };
        const margin = [0.5, 0.5];
        const filename = "myfile.pdf";

        var imgWidth = 8.5;
        var pageHeight = 11;

        var innerPageWidth = imgWidth - margin[0] * 2;
        var innerPageHeight = pageHeight - margin[1] * 2;

        // Calculate the number of pages.
        var pxFullHeight = canvas.height;
        var pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        var nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        var pageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        var pageCanvas = document.createElement("canvas");
        var pageCtx = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;

        // Initialize the PDF.
        var pdf = new jsPDF("p", "in", [8.5, 11]);

        for (var page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            pageHeight =
              (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }

          // Display the page.
          var w = pageCanvas.width;
          var h = pageCanvas.height;
          pageCtx.fillStyle = "white";
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          debugger;
          var imgData = pageCanvas.toDataURL(
            "image/" + image.type,
            image.quality
          );
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            pageHeight
          );
        }

        pdf.save("parent-reel.pdf");
      }
    );
  };

  useEffect(() => {
    if (jobId)
      exportAllParentReelDetails({ jobcard: jobId })
        .then((response) => {
          let parentReelsFromResponse = response.data.data;
          parentReelsFromResponse.forEach(reel => {
            let orderSizeString = "";
            let totalSize = 0;
            let partitionData;

            let leftData = reel.d_com.combinations.filter((order) => order.position === 'left');
            let rightData = reel.d_com.combinations.filter((order) => order.position === 'right');

            if(reel.cutter_type === "duplex"){
              let leftPartitionData = "( ";
              let rightPartitionData = "( ";
              
              reel.d_com.combinations.forEach((item, index) => {
              if(item.position === "left")
                leftPartitionData = leftPartitionData + item.width + " + ";
              else
                rightPartitionData = rightPartitionData + item.width + " + ";
              });

              if(leftData.length && rightData.length){
                leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);
                leftPartitionData = leftPartitionData + ") + ";
                rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);
                rightPartitionData = rightPartitionData + ")";
              }
  
              if(!leftData.length){
                leftPartitionData = '';
                rightPartitionData = rightPartitionData.substring(0, rightPartitionData.length-2);
                rightPartitionData = rightPartitionData + ")";
              }
    
              if(!rightData.length){
                rightPartitionData = '';
                leftPartitionData = leftPartitionData.substring(0, leftPartitionData.length-2);
                leftPartitionData = leftPartitionData + ")";
              }
              partitionData = leftPartitionData + rightPartitionData;
            }

            reel.d_com.combinations.forEach((item) => {
              let orderSize;
              if (item.item_type == "order") {
                orderSize = reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.grain == 'long' ?
                  (reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.width > reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.length)
                    ? reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.length :
                    reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.width :
                  (reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.length > reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.width)
                    ? reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.length :
                    reel.orders.filter(order => order.order === item.number)[0]?.order_dim?.width;
              }else {
                orderSize = reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim?.grain == 'long' ?
                  (reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.width > reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.length)
                    ? reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.length :
                    reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.width :
                  (reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.length > reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.width)
                    ? reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.length :
                    reel.orders.filter(order => order.stock === item.number)[0]?.stock_dim.width;
              }

              orderSizeString = !orderSizeString ? orderSize?.toString() : orderSizeString?.toString() + " + " + orderSize?.toString();
              totalSize = totalSize + orderSize;
            })
            
            reel["orderSizes"] = orderSizeString;
            reel["totalSize"] = totalSize;
            reel["duplexCombinationArr"] = partitionData;
          })
          setParentReelDetails(parentReelsFromResponse);
        })
        .catch((error) => console.log(error));
    return () => {
      setParentReelDetails();
    };
  }, [jobId]);

  const onBackClick = () => {
    window.history.back();
  }

  return parentReelDetails ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={onBackClick}
          title={location?.state?.machine_type !== "cutter" ? "Parent Reel Preview" : "Parent Set Preview"}
          extra={[
            <Button key="1" className="themeBtn" onClick={handlePrint}>
              <Iconmoon icon="printer" size={16} color="#FFFFFF" />
              {location?.state?.machine_type !== "cutter" ? "Print Parent Reels" : "Print Parent Set"}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <PrintData id="export-content">
        <OtherPages>
          <Layout
            style={{
              backgroundColor: "#ffffff",
            }}
          >
            <div ref={printRef}>
              <ExportHeader>
                <div className="file-header">
                  <div className="file-header-logo">
                    <img src={logoCompany} alt="Kaiznn" />
                  </div>
                  <div className="client-name">
                    <h4>Job Card Number: {jobcardCode}</h4>
                    <div className="client-data">
                      <div>
                        <label>Number of records</label>
                        <span>{parentReelDetails.length}</span>
                      </div>
                      <div>
                        <label>Date:</label>
                        <span>{moment(today).format("DD MMMM, YYYY")}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ExportHeader>
              {parentReelDetails.map((reel) => (
                <>
                  <ExportAdditional>
                    <div className="export-additional">
                      <div className="additional-col">
                        {/* <label>
                          D.COM:{" "}
                          {reel.orderSizes} = {reel.totalSize} CM
                        </label> */}
                        <label>
                          D.COM:{" "}
                          {reel.cutter_type === "duplex" ? (
                            `${reel.duplexCombinationArr}`
                            ) : (
                              reel.d_com.combinations.map(
                              (item, index, array) =>
                                `${item.width} ${
                                  index + 1 !== array.length ? "+" : ""
                                }`
                            ))}{" "} = {reel.d_com.total ? reel.d_com.total.toFixed(3) : "0.000"}
                            {" "}{reel?.units && reel?.units?.total ? lengthUnit[reel.units.total]?.displayName?.toUpperCase() : "CM"}
                      </label>
                        <p>Left Trim: {reel.left_edge_trim} {" "} {reel?.units && reel?.units?.left_edge_trim ? lengthUnit[reel.units.left_edge_trim]?.displayName?.toUpperCase() : "CM"}</p>
                        <p>Right Trim: {reel.right_edge_trim} {" "} {reel?.units && reel?.units?.left_edge_trim ? lengthUnit[reel.units.left_edge_trim]?.displayName?.toUpperCase() : "CM"}</p>
                        <p>Deckle Width: {reel.deckle_width} {" "} {reel?.units && reel?.units?.deckle_width ? lengthUnit[reel.units.deckle_width]?.displayName?.toUpperCase() : "CM"}</p>
                      </div>
                      <div className="additional-col">
                        <label>GSM: {reel.gsm} </label>
                        <p>Burst Factor: {reel.burst_factor}</p>
                        <p>Grade: {reel.grade}</p>
                        <p>Quality: {reel.quality} </p>
                        {location?.state?.machine_type !== "cutter" ? (<p>
                          ID / OD: {reel.core_id} / {reel.reel_od} {" "} {reel?.units && reel?.units?.reel_od ? lengthUnit[reel.units.reel_od]?.displayName?.toUpperCase() : "CM"}
                        </p>) : (null)}
                      </div>
                      <div className="additional-col">
                        {/* <label>Parent Reel No.: {parentReel}</label> */}
                        <p>
                          Jumbo Reels:{" "}
                          {reel.jumbo_reels.map(
                            (item, index, array) =>
                              `${item.number} (${item.weight} ${" "} ${item.units && item.units.weight ? capitalize(weightUnit[item.units.weight]?.displayName) : "T"})${
                                index + 1 !== array.length ? ", " : ""
                              }`
                          )}
                        </p>
                        {reel.rewinding_date && location?.state?.machine_type !== "cutter" && <p>
                          Rewinding Date:{" "}
                          {moment(reel.rewinding_date).format("DD-MM-YYYY")}
                        </p>}
                        {!reel.rewinding_date && location?.state?.machine_type !== "cutter" && <p>
                          Rewinding Date:
                        </p>}

                        {reel.cutting_date && location?.state?.machine_type === "cutter" && <p>
                          Cutting Date:{" "}
                          {moment(reel.cutting_date).format("DD-MM-YYYY")}
                        </p>}
                        {!reel.cutting_date && location?.state?.machine_type === "cutter" && <p>
                          Cutting Date:
                        </p>}

                        {location?.state?.machine_type !== "cutter" ? (
                        <p>Rewinding Shift: {reel.rewinding_shift}</p>) : (
                        <p>Cutting Shift: {reel.cutting_shift}</p>
                        )}
                      </div>
                    </div>
                  </ExportAdditional>
                  <ExportTable>
                    <table>
                      <thead>
                        <tr>
                          <th>ORDER DETAILS</th>
                          {location?.state?.machine_type !== "cutter" ? (<th>REEL NUMBER</th>) : (<th>SHEET NUMBER</th>)}
                          {location?.state?.machine_type !== "cutter" ? (<th>REEL WEIGHT</th>) : (<th>SHEET WEIGHT</th>)}
                          <th>ORDER DIMENSION</th>
                          <th>CUSTOMER DETAILS</th>
                          <th>PRIORITY</th>
                          <th>REMARKS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reel.orders.map((order) => (
                          <tr>
                            {order.item_type === "order" ? (
                              <td>
                               <p className="p-ton f-10">PO/SO NO.: {toHandlePOName(order.po||order.so)}</p>
                                <p className="p-ton f-10">ORDER NO.: {order.order}</p>
                              </td>
                            ) : (
                              <td >
                                <p className="p-ton f-10">STOCK NO.: {order.stock}</p>
                              </td>
                            )}
                            <td>
                              <p className="p-detail f-10">{order.reel}</p>
                            </td>
                            <td>
                              <p className="p-ton f-10">
                                {order.reel_weight? order.reel_weight?.toFixed(3) : 0 } {" "} {order.units && order.units.reel_weight ? capitalize(weightUnit[order.units.reel_weight]?.displayName) : "T"}
                              </p>
                            </td>
                            <td>
                              <p className="p-ton f-10">
                                {order.item_type === "order" ? order.order_dim?.length : order.stock_dim.length} x{" "}
                                {order.item_type === "order" ? order.order_dim?.width : order.stock_dim.width} {" "} {order?.units && order?.units?.width ? lengthUnit[order.units.width]?.displayName?.toUpperCase() : "CM"}
                              </p>
                              <p className="reel f-10">
                                {order.item_type === "order" ? order.order_dim?.grain : order.stock_dim.grain}
                              </p>
                            </td>
                            {order.item_type === "order" ? (
                              <td>
                                <p className="p-ton f-10">
                                  Customer: {order.category==='so'?'SO':order.customer ? order.customer.name : ""}
                                </p>
                                {order.delivery_date && <p className="reel f-10">
                                  Delivery Date:{" "}
                                  {moment(order.delivery_date).format(
                                    "DD-MM-YYYY"
                                  )}
                                </p>}
                                {!order.delivery_date && order.category!='so' && <p className="reel f-10">
                              Delivery Date:</p>}
                              </td>
                            ) : (
                              <td >
                                <p className="p-ton f-10">-</p>
                              </td>
                            )}
                            {order.item_type === "order" ? (
                              <td >
                                {order.forced && <p className="p-ton f-10">YES</p>}
                                {!order.forced && <p className="p-ton f-10">NO</p>}
                              </td>
                            ) : (
                              <td >
                                <p className="p-ton f-10">-</p>
                              </td>
                            )}
                            <td>
                              <p className="remark f-10">{order.remarks}</p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </ExportTable>
                </>
              ))}
            </div>
          </Layout>
        </OtherPages>
      </PrintData>
    </RightLayoutContainer>
  ) : null;
};

export default PrintJobCardPdf;
